import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { ConfigModule, provideDefaultConfig } from '@spartacus/core';
import { CustomProductListComponent } from './components/custom-product-list/custom-product-list.component';
import { CustomOccCartEntryAdapter } from '../adapters/custom-occ-cart-entry-adapter.service';
import { CartEntryAdapter } from '@spartacus/cart/base/core';
import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';
import { CustomCxAddedToCartDialogComponent } from '@shared/custom-cx-added-to-cart-dialog/custom-cx-added-to-cart-dialog.component';
import { SharedModule } from '@shared/shared.module';
import { AddedToCartDialogEventListener } from '@spartacus/cart/base/components';
import { CustomAddedToCartDialogEventListener } from '@services/custom-added-to-cart-dialog-event.listener';
import { CustomProductFacetNavigationComponent } from './components/custom-product-facet-navigation/custom-product-facet-navigation.component';

export const customAddToCartLayoutConfig: LayoutConfig = {
  launch: {
    MODAL_CART: {
      inlineRoot: true,
      component: CustomCxAddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComponentsModule,
    SharedModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SearchResultsListComponent: {
          component: CustomProductListComponent,
        },
        AddedToCartDialogComponent: {
          component: CustomCxAddedToCartDialogComponent,
        },
        // For category page
        ProductGridComponent: {
          component: CustomProductListComponent,
        },
        ProductRefinementComponent: {
          component: CustomProductFacetNavigationComponent
        }
      },
    }),
  ],
  providers: [
    {
      provide: CartEntryAdapter,
      useClass: CustomOccCartEntryAdapter,
    },
    provideDefaultConfig(customAddToCartLayoutConfig),
    {
      provide: AddedToCartDialogEventListener,
      useExisting: CustomAddedToCartDialogEventListener,
    },
  ],
})
export class CustomProductListPageModule {}
